<style type="less" scoped>
    @import url('./css.less');
</style>
<template>
    <div class="container">
        <BusinessEchartBmap v-on:map-load="mapLoad" v-bind="$props" ref='map'>
        </BusinessEchartBmap>
    </div>
</template>

<script>
    import BusinessEchartBmap from './../../map/common/businessEchartBmap/index';
    import mapPropsMinxin from './default-props-value';
    import ScatterCircleOverlay from './../common/echartOverlay/ScatterCircleOverlay';
    const axios = require('axios');
    import {
        colToRow,
        rowsToGeo
    } from './../../../lib/utils';
    export default {
        name: '',
        mixins: [mapPropsMinxin],
        components: {
            BusinessEchartBmap
        },
        data() {
            const cacheData = {
                overlay: null
            };
            return {
                getCacheData() {
                    return cacheData;
                }
            }
        },
        watch: {
            api() {
                api && this.ajaxData();
            },
            symbol() {
                this.setOption();
            },
            symbolSize() {
                this.setOption();
            }
        },
        computed: {},
        methods: {
            symbolFormat() {
                const types = `'circle','rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow'`;
                if (types.indexOf(`'${this.symbol}'`) > -1) {
                    return this.symbol;
                } else {
                    return `image://${this.symbol}`;
                }
            },
            _initMap() {
                const mapComponent = this.$refs.map.getMapComponent();
                const overlay = new ScatterCircleOverlay({
                    symbol: this.symbolFormat(),
                    symbolSize: this.symbolSize
                });
                mapComponent.setEchartLayers([overlay]);
                this.getCacheData().overlay = overlay;
            },
            setOption() {
                const overlay = this.getCacheData().overlay;
                if (overlay == null) return;

                const mapComponent = this.$refs.map.getMapComponent();
                overlay.options.symbol = this.symbolFormat();
                overlay.options.symbolSize = this.symbolSize;
                mapComponent.setEchartLayers([overlay]);
            },
            ajaxData() {
                axios.get(this.api)
                    .then((response) => {
                        const data = response.data;
                        const rows = colToRow(data);
                        const geoData = rowsToGeo(rows);
                        const mapComponent = this.$refs.map.getMapComponent();
                        const overlay = this.getCacheData().overlay;
                        overlay.setValue(geoData);
                        mapComponent.setEchartLayers([overlay]);
                    });
            },
            mapLoad() {
                this._initMap();
                this.ajaxData();
            },
            resize() {
                this.$refs.map.resize();
            }
        },
        mounted() {

        }
    }
</script>